import config from '../../../config/config-default';

const loadJson = async (fileName) => {
	const response = await fetch(
		`https://bookings.skipbinbrisbane.com.au/json/${fileName}.json`,
		{
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	return response.json();
};

const initStep1 = async (params = {}) => {
	const binType = document.getElementById('bin-type');
	const binSize = document.getElementById('bin-size');
	const charge = document.getElementById('charge');
	const weight = document.getElementById('weight');
	const chargeDisplay = document.getElementById('charge-display');
	const weightDisplay = document.getElementById('weight-display');
	const weightRate = document.getElementById('weight-rate');

	const [bins, costs] = await Promise.all([
		loadJson('bins'),
		loadJson('costs'),
	]);
	window[config.globalScope].options = {};
	window[config.globalScope].options.bins = bins;
	window[config.globalScope].options.costs = costs;

	let html = '';
	for (let i = 0; i < bins.length; i += 1) {
		const { size, cost } = bins[i];
		html += `<option value="${size}m">${size}m<sup>3</sup> Skip Bin - $${cost.toLocaleString(
			'en-AU',
			{ minimumFractionDigits: 2, maximumFractionDigits: 2 },
		)} inc GST</option>`;
	}
	binSize.insertAdjacentHTML('beforeend', html);

	weightRate.textContent = (costs.per_100kg_over || 0).toFixed(2);

	binSize.addEventListener('change', () => {
		const selectedBin =
			bins.find((bin) => bin.size === +binSize.value.slice(0, -1)) || {};
		charge.value = selectedBin.cost || 0;
		weight.value = selectedBin.max_weight || 0;
		chargeDisplay.textContent = (selectedBin.cost || 0).toFixed(2);
		weightDisplay.textContent = selectedBin.max_weight || 0;
	});

	const qsParams = params || {};
	if (['garden', 'junk'].includes(qsParams.type)) {
		binType.value = `${qsParams.type
			.charAt(0)
			.toUpperCase()}${qsParams.type.slice(1)} Skip Bin`;
	}
	if (qsParams.size) {
		binSize.value = qsParams.size;
		binSize.dispatchEvent(new Event('change'));
	}
};

export default initStep1;
